export default __webpack_public_path__ + "static/media/Amper-1999.81edd524.svg";